import { ReactNode, ReactText } from 'react';

import { Box, Card as MUICard, CardHeader, CardProps as MUICardProps, Typography } from '@mui/material';

import { stickyHeaderStyles } from './StickyHeader.styles';

export interface StickyHeaderProps extends MUICardProps {
  titleSport?: ReactText;
  titleType: ReactText;
  titleId?: ReactText;
  titleName?: ReactText;
  titleExtra?: ReactNode;
  children?: ReactNode;
}

const StickyHeader = ({
  titleSport = '',
  titleType = '',
  titleId = '',
  titleName = '',
  titleExtra,
  children,
}: StickyHeaderProps) => (
  <MUICard elevation={3} sx={stickyHeaderStyles.stickyHeaderCard}>
    <CardHeader
      id="sticky-header-wrapper"
      sx={stickyHeaderStyles.stickyHeader}
      title={
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="h5" component="span" sx={stickyHeaderStyles.title}>
            {`${titleSport} ${titleType}`.trim()}
          </Typography>
          {titleExtra}
        </Box>
      }
      subheader={titleId && titleName ? `${titleId} │ ${titleName}`.trim() : null}
      subheaderTypographyProps={{
        type: 'body1',
        color: 'textPrimary',
        sx: stickyHeaderStyles.subheader,
      }}
    />
    <Box id="sticky-header-errors" />
    {children}
  </MUICard>
);
export default StickyHeader;
